import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import TripSidebarContent from '@/components/trip/sidebar/TripSidebarContent.vue'

export interface TripSidebarProps {
  value: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TripSidebar',
  props: {
    value: { type: Boolean }
  },
  emits: ['input'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  value: boolean
};





const isExpanded = computed({
  get: () => props.value,
  set: (value) => {
    emits('input', value)
  },
})

return { __sfc: true,props, emits, isExpanded, TripSidebarContent }
}

})